import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from "material-ui";
import Subheader from 'material-ui/Subheader';
import {connect} from "react-redux";
import Loading from "../../../components/common/Loading/Loading";
import {fetchApp, resetAppAction, putApp} from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './EditApplicationPage.css';
import ApplicationForm from "../../../components/application/ApplicationForm/ApplicationForm";
import withTranslation from "../../../hoc/withTranslation";
import {APPLICATION_PAGE} from "../../../constants/routes";

export class EditApplicationPage extends React.Component {

    static propTypes = {
        app: PropTypes.object
    };

    static defaultProps = {
        loading: true,
        app: null,
        sending: false
    };

    componentWillMount() {
        this.fetchApplication();
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending && !nextProps.appError) {
            this.props.history.push(APPLICATION_PAGE.replace(':appId', this.props.app.id));
        }

    }

    // Fetch

    fetchApplication() {
        if (this.props.match) {
            const id = this.props.match.params.appId;
            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
       await this.props.putApp(formProps.id, formProps);
    };

    render() {
        if (this.props.loading || !this.props.app) {
            return <Loading paper={false}/>;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t('generic.application')} / {this.props.t('generic.edit')}</h3>
                    <Paper style={styles.editBox}>
                        <Subheader style={style.subHeader}>{this.props.app.name}</Subheader>

                        <div style={style.paper}>
                            <ApplicationForm
                                onSubmit={this.handleFormSubmit}
                                initialValues={this.props.initialValues}
                                submitting={this.props.sending}
                                app={this.props.app}
                            />
                        </div>
                        <div style={style.clear}/>
                    </Paper>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending,
        appError: state.apps.error
    };

    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
        props.sending = state.apps.sending;
        props.initialValues = state.apps.currentApplication;
    }
    return props;
}

export default connect(mapStateToProps, {fetchApp, resetAppAction, putApp})(withTranslation(EditApplicationPage));



// WEBPACK FOOTER //
// src/containers/application/EditApplicationPage/EditApplicationPage.js